import { createSlice } from '@reduxjs/toolkit';

export const signupSlice = createSlice({
    name: 'signup',
    initialState: {
        successMessage: "",
        error: "",
        addressError: "",
        usernameError: "",
        promotionalCode: "",
        codeValid: false,
        properties: [],
    },
    reducers: {
        updateState: (state, action) => {
            state.error = action.payload.error;
            state.successMessage = action.payload.successMessage;
            state.usernameError = action.payload.usernameError || "";
            state.addressError = action.payload.addressError || "";
        },
        updateProperties: (state, action) => {
            state.properties = action.payload.properties || [];
        },
        signup: () => {},
        addressValidation: () => {},
        usernameValidation: () => {},
        errorSignupRefresh: () => {},
        getPropertyList: () => {},
        validatePromotionalCode: (state, action) => {
            state.codeValid = action.payload.codeValid || false;
            state.promotionalCode = action.payload.promotionalCode || "";
        },
        callValidatePromotionalCode: () => {}
    },
})

export const {
    signup,
    updateState,
    updateProperties,
    addressValidation,
    usernameValidation,
    errorSignupRefresh,
    getPropertyList,
    validatePromotionalCode,
    callValidatePromotionalCode
} = signupSlice.actions

export default signupSlice.reducer;
